import React from 'react';

const ThankYou = () => (
  <iframe
    src="https://www.beezer.com/thank-you-page/"
    width="100%"
    height="100%"
    title="Beezer Thank You Page"
  />
);

export default ThankYou;
